import { adminApi } from '../../../../store/generated/admin/templates';

export enum RecommendationApiTags {
  Templates = 'recommendation-templates',
}

const templatesApi = adminApi.enhanceEndpoints({
  addTagTypes: [RecommendationApiTags.Templates],
  endpoints: {
    apiAdminV1RecommendationTemplateList: {
      providesTags: [RecommendationApiTags.Templates],
    },
    apiAdminV1RecommendationTemplateRetrieve: {
      providesTags: [RecommendationApiTags.Templates],
    },
    apiAdminV1RecommendationTemplateUpdate: {
      invalidatesTags: [RecommendationApiTags.Templates],
    },
    apiAdminV1RecommendationTemplateCreate: {
      invalidatesTags: [RecommendationApiTags.Templates],
    },
    apiAdminV1RecommendationTemplateDestroy: {
      invalidatesTags: [RecommendationApiTags.Templates],
    },
    apiAdminV1RecommendationTemplatePartialUpdate: {
      invalidatesTags: [RecommendationApiTags.Templates],
    },
  },
});

export { templatesApi };
